import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=866825b2&scoped=true"
import script from "./paging.vue?vue&type=script&lang=js"
export * from "./paging.vue?vue&type=script&lang=js"
import style0 from "./paging.vue?vue&type=style&index=0&id=866825b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866825b2",
  null
  
)

export default component.exports